module.exports = __webpack_public_path__ + "static/b_clint-02149f9615b048583c5aedab130cb099.jpeg";